<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog v-model="manageUsersDialog" max-width="1000">
            <v-card>
                <v-card-title>
                    Manage user
                </v-card-title>
                <v-card-text>
                    <v-card>
                        <v-card-title>User data</v-card-title>
                        <v-card-text>
                            <!-- <v-text-field label="Old password" v-model="oldpwd" /> -->
                            <v-text-field outlined label="Username" />
                            <v-text-field outlined label="Registration email" />
                            <v-text-field outlined label="Real name" />
                            <v-select outlined label="User group" :items="sel_items"></v-select>
                        </v-card-text>
                    </v-card>
                    <v-card class="mt-4">
                        <v-card-title>App-Menu</v-card-title>
                        <v-card-text>
                            <v-data-table v-bind:headers="menuHeaders" :items="menuItems" class=".my-data-table-class" no-data-text="No users connected yet">
                                <template v-slot:item="{ item }">
                                    <tr class=".my-data-table-class">
                                        <td class=".my-data-table-class"> {{ item.page }} </td>
                                        <td> {{ item.section }} </td>
                                        <td> <v-icon>mdi-delete </v-icon></td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card class="mt-4">
                        <v-card-title>Buildings Permissions</v-card-title>
                        <v-card-text>
                            <v-data-table no-data-text="No users connected yet"></v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card class="mt-4">
                        <v-card-title>Floors Permissions</v-card-title>
                        <v-card-text>
                            <v-data-table no-data-text="No users connected yet"></v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card class="mt-4">
                        <v-card-title>Areas Permissions</v-card-title>
                        <v-card-text>
                            <v-data-table no-data-text="No users connected yet"></v-data-table>
                        </v-card-text>
                    </v-card>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#234a98" text @click="manageUsersDialog = false">Save</v-btn>
                    <v-btn color="#234a98" text @click="manageUsersDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="600">
            <v-card>
                <v-card-title>
                    {{ $t('users.changePasswordTitle') }}
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="passwordForm" v-model="isPasswordFormValid">
                        <v-text-field 
                            :label="$t('users.oldPassword')" 
                            v-model="oldpwd" 
                            outlined 
                            color="#213A8F"
                            :type="showOldPassword ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock-outline"
                            :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showOldPassword = !showOldPassword"
                            :rules="[rules.required]"
                            maxlength="50"
                            counter
                        />
                        <v-text-field 
                            :label="$t('users.newPassword')" 
                            v-model="newpwd1" 
                            outlined 
                            color="#213A8F"
                            :type="showNewPassword1 ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock"
                            :append-icon="showNewPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showNewPassword1 = !showNewPassword1"
                            :rules="[rules.required, rules.minLength]"
                            maxlength="50"
                            counter
                        />
                        <v-text-field 
                            :label="$t('users.confirmNewPassword')" 
                            v-model="newpwd2" 
                            outlined 
                            color="#213A8F"
                            :type="showNewPassword2 ? 'text' : 'password'"
                            prepend-inner-icon="mdi-lock-check"
                            :append-icon="showNewPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showNewPassword2 = !showNewPassword2"
                            :rules="[rules.required, rules.passwordMatch]"
                            maxlength="50"
                            counter
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="SaveNewPassword()" :disabled="!isPasswordFormValid">{{ $t('common.save') }}</v-btn>
                    <v-btn text color="#213A8F" @click="closePasswordDialog()">{{ $t('common.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-data-table v-bind:headers="headers" :items="items" :hide-default-footer="true" disable-pagination
                class="elevation-1" no-data-text="No users connected yet">
                <template v-slot:item="{ item }">
                    <tr>
                        <td></td>
                        <td>{{ item.email }}</td>
                        <td><v-icon
                                :style="item.Active == 0 ? 'color: red;' : 'color: green;'">mdi-checkbox-blank-circle</v-icon>
                        </td>
                        <td>{{ item.LevelName }}</td>
                        <td>{{ item.CompanyName }}</td>
                        <td>
                            <v-btn prepend-icon="mdi-cog" @click="editItem(item)">{{ $t('users.changePassword') }}</v-btn>
                           <!-- <v-btn prepend-icon="mdi-cog" @click="manageUsersDialog = true">{{ $t('users.manageUser') }}</v-btn> -->
                            <!-- <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" small class="mr-2" @click="editItem(item)">mdi-lock</v-icon>
                                </template>
        <span>Change password</span>
        </v-tooltip> -->
                            <!-- <v-icon small class="mr-2" @click="editItem(item)">mdi-delete</v-icon> -->
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-snackbar v-model="snackbar" :timeout="timeout" color="red accent-2">
            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    OK
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="snackbarGreen" :timeout="timeout" color="green accent-2">
            {{ snackbarGreenText }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    OK
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            menuHeaders: [
                { text: "Page", align: "center", value: "page" },
                { text: "Section", align: "center", value: "section" },
            ],
            menuItems: [
                { page: "Dispenser", section: "SENSORS" },
                { page: "Dashboards", section: "SENSORS" }
            ],
            sel_items: [
                { text: "Youtissue Admin" },
                { text: "Distributor" },
                { text: "Client" },
                { text: "Facility Manager" },
                { text: "Cleaner" }
            ],
            manageUsersDialog: false,
            snackbar: false,
            snackbarText: '',
            snackbarGreen: false,
            snackbarGreenText: '',

            items: [],
            dialog: false,
            id_mod: 0,
            newpwd1: '',
            newpwd2: '',
            overlay: true,
            oldpwd: '',
            timeout: 2000,
            isPasswordFormValid: false,
            showOldPassword: false,
            showNewPassword1: false,
            showNewPassword2: false,
            rules: {
                required: value => !!value || this.$t('validation.required'),
                minLength: value => (value && value.length >= 6) || this.$t('users.passwordMinLength'),
                passwordMatch: value => value === this.newpwd1 || this.$t('users.passwordMismatch')
            }
        }
    },
    computed: {
        headers() {
            return [{},
            { text: this.$t('users.username'), align: "center", value: "email" },
            { text: this.$t('users.active'), align: "center", value: "Active" },
            { text: this.$t('users.role'), align: "center", value: "Gruppo" },
            { text: this.$t('manageSensors.company'), align: "center", value: "CompanyName" },
            { text: this.$t('manageSensors.actions'), align: "center", value: "" }, {}]
        }
    },
    created() {
        this.overlay = true;
        axios.post(this.$store.state.URL_GET_USERS,
            {
                company: this.$store.state.company
            })
            .then(res => {
                this.items = res.data
                this.overlay = false;
            });
    },
    methods: {
        editItem(item) {
            this.id_mod = item.Id;
            this.dialog = true;
            this.oldpwd = '';
            this.newpwd1 = '';
            this.newpwd2 = '';
            this.isPasswordFormValid = false;
            this.showOldPassword = false;
            this.showNewPassword1 = false;
            this.showNewPassword2 = false;
            if (this.$refs.passwordForm) {
                this.$refs.passwordForm.resetValidation();
            }
        },
        closePasswordDialog() {
            this.dialog = false;
            this.oldpwd = '';
            this.newpwd1 = '';
            this.newpwd2 = '';
            this.isPasswordFormValid = false;
            this.showOldPassword = false;
            this.showNewPassword1 = false;
            this.showNewPassword2 = false;
            if (this.$refs.passwordForm) {
                this.$refs.passwordForm.resetValidation();
            }
        },
        SaveNewPassword() {
            if (!this.isPasswordFormValid) {
                return;
            }

            this.overlay = true;
            
            axios.post(this.$store.state.URL_CHANGE_USER_PASSWORD, {
                id: this.id_mod,
                new: this.newpwd1,
                old: this.oldpwd
            })
                .then(res => {
                    this.overlay = false;
                    if (res.data === 'updated') {
                        this.snackbarGreenText = this.$t('users.passwordChangedSuccess');
                        this.snackbarGreen = true;
                        this.closePasswordDialog();
                    }
                    else {
                        this.snackbarText = res.data;
                        this.snackbar = true;
                    }
                })
                .catch(() => {
                    this.overlay = false;
                    this.snackbar = true;
                    this.snackbarText = this.$t('users.passwordChangeError');
                })
        }
    }
}
</script>
<style scoped>
.my-data-table-class {
    all: unset;
    /* o unset, initial a seconda delle tue necessità */
}
</style>